import { render, staticRenderFns } from "./salesPriceStrategyAction.vue?vue&type=template&id=5962bf68&scoped=true"
import script from "./salesPriceStrategyAction.vue?vue&type=script&lang=js"
export * from "./salesPriceStrategyAction.vue?vue&type=script&lang=js"
import style0 from "./salesPriceStrategyAction.vue?vue&type=style&index=0&id=5962bf68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5962bf68",
  null
  
)

export default component.exports